export const Colors = {
  primaryText: "#818A91",
  background: "rgb(243, 249, 255)",
  darkBlue: "#004990",
  lightBlue: "#c6d7dabd",
};
